<template>
    <div id="spin">
        <a-spin :tip="`正在${msg}，请稍后`"
                v-if="isShow"
                :indicator="indicator" />
        <a :href="href"
           style="display: none"
           id="export_a">下载</a>
    </div>
</template>
 
<script>
import api from "../../http/api";
export default {
    created() {
        this.getResult();
    },
    data() {
        return {
            isShow: true,
            msg: "",
            seqNumber: "",
            href: "",
            indicator: (
                <my-icon type="iconloading2" style="font-size:50px" spin />
            ),
            pickRoomPlanId: ""
        };
    },
    methods: {
        getResult() {
            let _this = this;
            setTimeout(() => {
                api.getResult({ seqNumber: this.seqNumber }).then(res => {
                    if (
                        res.returnCode == "000000" &&
                        res.param.entity.finished == 1
                    ) {
                        this.isShow = false;
                        if (this.msg == "导出") {
                            window.location.href = res.param.entity.download;
                            return;
                        } else if (this.msg == "排宿") {
                            const h = this.$createElement;
                            this.$success({
                                title: `成功`,
                                content: h("div", {}, [
                                    h(
                                        "p",
                                        `已成功${this.msg}${
                                            res.param.entity.succesCount
                                        }个`
                                    ),
                                    h(
                                        "p",
                                        `失败数:${res.param.entity.failCount}`
                                    )
                                ]),
                                okText: "确认",
                                onOk() {
                                    _this.onOk();
                                }
                            });
                        } else if (this.msg == "撤销") {
                            const h = this.$createElement;
                            this.$success({
                                title: `成功`,
                                content: h("div", {}, [
                                    h(
                                        "p",
                                        `已成功${this.msg}${
                                            res.param.entity.succesCount
                                        }个床位`
                                    ),
                                    h(
                                        "p",
                                        `失败数:${res.param.entity.failCount}`
                                    )
                                ]),
                                okText: "确认",
                                onOk() {
                                    _this.onOk();
                                }
                            });
                        } else if (this.msg == "发布") {
                            let _this = this;
                            const h = this.$createElement;
                            api.AddPlanAsync({
                                pickRoomPlanId: this.pickRoomPlanId
                            }).then(res_lsat => {
                                _this.$success({
                                    title: `成功`,
                                    content: h("div", {}, [
                                        h(
                                            "p",
                                            `已成功${this.msg}:${
                                                res.param.entity.succesCount
                                            }个`
                                        ),
                                        h(
                                            "p",
                                            `失败数:${
                                                res.param.entity.failCount
                                            }`
                                        )
                                    ]),
                                    okText: "确认",
                                    onOk() {
                                        _this.onOk();
                                    }
                                });
                            });
                        }
                    } else if (
                        res.returnCode == "000000" &&
                        res.param.entity.finished == 2
                    ) {
                        this.isShow = false;
                        this.$error({
                            title: "错误",
                            content: this.msg + "失败"
                        });
                    } else {
                        this.getResult();
                    }
                });
            }, 1000);
        }
    }
};
</script>
<style lang="scss">
// #spin {
//     .ant-spin {
//         position: fixed;
//         width: 100%;
//         height: 100vh;
//         top: 0;
//         left: 0;
//         background-color: rgba(0, 0, 0, 0.4);
//         text-align: center;
//         z-index: 1111;
//         color: #fff;
//         line-height: 100vh;sa
//         .ant-spin-text {
//             text-align: center;
//             position: absolute;
//             top: 53%;
//             left: 50%;
//             transform: translateX(-32%);
//             color: #fff;
//         }
//     }
// }
</style>

